import { ExibirTermosDeUso } from "views/components/render-modais/components/termos-de-uso-modal"

export const RenderModaisPublic = ()=>{
    return (
        <ExibirTermosDeUso/>
    )
}